<script setup lang="ts">
declare const window: {
  moli: {
    que: any[];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    refreshAdSlot: Function;
  };
  googletag: {
    cmd: any[];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    pubads: Function;
  };
};

/********************
 * COMPOSITIONS      *
 ********************/
const attrs = useAttrs();
const { trackAdImpression } = useTracking();

/********************
 * REFS & VARS       *
 ********************/
const isRendered = ref(false);

/********************
 * FUNCTIONS         *
 ********************/
function trackImpression(event, slotId: string) {
  trackAdImpression({
    advertiserId: event.advertiserId?.toString() || null,
    bannerId: event.creativeId?.toString() || null,
    campaignId: event.campaignId?.toString() || null,
    costModel: 'cpm',
    zoneId: slotId,
  });
}

function onSlotRenderEnded(event) {
  const slotId = event.slot.getSlotElementId();
  // don't render for excluded advertiser ids
  // (!!event.advertiserId &&
  //   disallowedAdvertiserIds.includes(event.advertiserId)) ||
  if (slotId === attrs.id) {
    isRendered.value = !event.isEmpty;

    if (!event.isEmpty) {
      trackImpression(event, slotId);
    }
  }
}

/********************
 * HOOKS             *
 ********************/
onMounted(() => {
  const id = attrs.id;

  if (id) {
    window.moli = window.moli || { que: [] };
    try {
      window.moli.que.push(() => {
        window.moli.refreshAdSlot(id).catch(() => {});
      });
    } catch (_e) {
      // Error is okay
    }
  }

  window.googletag = window.googletag || { cmd: [] };
  window.googletag.cmd.push(() => window.googletag.pubads().addEventListener('slotRenderEnded', onSlotRenderEnded));
});

onBeforeUnmount(() => {
  window.googletag?.pubads?.().removeEventListener?.('slotRenderEnded', onSlotRenderEnded);
});
</script>

<template>
  <div
    class="ad ci-ad-slot"
    :class="{ 'ad--rendered': isRendered }"
  />
</template>
